import React from "react";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { ClientReceiptInfo } from "../../components/client/ClientReceipt.component";

export const ClientReceipt = () => {
  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title="Client Receipt" />
      </Box>

      <ClientReceiptInfo />
    </PageLayout>
  );
};
